import React, { useState } from "react";
import {
  Input,
  Button,
  Badge,
  InputGroup,
  InputGroupAddon,
  Label,
} from "reactstrap";

const DealTagInputSection = ({
  label,
  placeholder,
  valueKey, // "siteNames" or "bundleIds" or custom
  badgeColor = "info",
  formState,
  setFormState,
  formData,
  onChange,
  error = "",
  plain = false, // when true, store plain string array instead of objects
  objectKey = "value", // when not plain, use this object key for stored objects
}) => {
  const [inputValue, setInputValue] = useState("");

  /* -------------------------
     Add item
  -------------------------- */
  const addItem = () => {
    if (!inputValue.trim()) return;

    // Prefer setFormState when available (older components). Otherwise use onChange/formData.
    if (setFormState && formState) {
      setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          [valueKey]: [
            ...(prev.values[valueKey] || []),
            plain ? inputValue.trim() : { [objectKey]: inputValue.trim() },
          ],
        },
        errors: {
          ...prev.errors,
          [valueKey]: "",
        },
      }));
    } else if (onChange && formData) {
      const existing = Array.isArray(formData[valueKey]) ? formData[valueKey] : [];
      const newVal = [...existing, (plain ? inputValue.trim() : { [objectKey]: inputValue.trim() })];
      onChange({ target: { name: valueKey, value: newVal } });
    }

    setInputValue("");
  };

  /* -------------------------
     Remove item
  -------------------------- */
  const removeItem = (index) => {
    if (setFormState && formState) {
      setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          [valueKey]: (prev.values[valueKey] || []).filter((_, i) => i !== index),
        },
      }));
    } else if (onChange && formData) {
      const existing = Array.isArray(formData[valueKey]) ? formData[valueKey] : [];
      const newVal = existing.filter((_, i) => i !== index);
      onChange({ target: { name: valueKey, value: newVal } });
    }
  };

  /* -------------------------
     Handle typing
  -------------------------- */
  const handleChange = (e) => {
    setInputValue(e.target.value);

    // ✅ clear only this field's error
    if (setFormState && formState) {
      setFormState((prev) => ({
        ...prev,
        errors: {
          ...prev.errors,
          [valueKey]: "",
        },
      }));
    } else if (onChange && formData) {
      // Trigger parent's onChange with current value to allow it to clear errors.
      const existing = formData[valueKey] !== undefined ? formData[valueKey] : [];
      onChange({ target: { name: valueKey, value: existing } });
    }
  };

  return (
    <>
      <Label>
        {label}
        {/* <span className="text-danger ml-1">*</span> */}
      </Label>

      <InputGroup>
        <Input
          value={inputValue}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addItem();
            }
          }}
          invalid={Boolean(error)}
        />

        <InputGroupAddon addonType="append">
          <Button
            className="btn-gradient-primary"
            onClick={addItem}
            disabled={!inputValue.trim()}
          >
            Add
          </Button>
        </InputGroupAddon>
      </InputGroup>

      {/* Error message */}
      {error && <p className="text-warning small mt-1">{error}</p>}

      {/* Badges */}
      <div className="mt-2">
        {(formState?.values?.[valueKey] || formData?.[valueKey] || []).map((item, i) => (
        <Badge key={i} color={badgeColor} className="mr-2">
          {plain ? item : item?.[objectKey]}
          <span
            className="ml-2 pointer"
            style={{ cursor: "pointer" }}
            onClick={() => removeItem(i)}
          >
            ×
          </span>
        </Badge>
      ))}
      </div>
    </>
  );
};

export default DealTagInputSection;
